// Post-login selection gate states. Kept out of organization.constants.js,
// which drags in moment-timezone.
export const ORGANIZATION_SELECTION_STATUS = /** @type {const} */ ({
  IDLE: 'idle',
  RESOLVING: 'resolving',
  PENDING: 'pending',
  DONE: 'done',
});
